import React from 'react';
import { translate } from 'react-i18next';
import {
  Avatar,
  Heading,
  Text,
  CustomModalLayout,
  Button,
  FormField,
  InputArea,
} from 'wix-style-react';
import ReviewItem from '../ReviewItem/ReviewItem';
import s from './replyReviewModalLayout.scss';

const ReplyReviewModalLayoutDesktop = ({
  t,
  closeReplyModal,
  replyToReview,
  disableReplyButton,
  expertDetails,
  selectedReview,
  onInputAreaChange,
}) => {
  return (
    <CustomModalLayout
      dataHook="reply-to-review-modal-layout"
      className={s.replyToReviewModalDesktop}
      primaryButtonText={t('expert-replyreview-ctabutton')}
      title={
        <div style={{ padding: '24px 42px 24px 30px' }}>
          <Heading appearance="H1" style={{ marginBottom: '12px' }}>
            {t('expert-replyreview-title')}
          </Heading>
          <Text>{t('expert-replyreview-description')}</Text>
        </div>
      }
      onCloseButtonClick={closeReplyModal}
      primaryButtonOnClick={replyToReview}
      primaryButtonProps={{ disabled: disableReplyButton }}
      sideActions={
        <Button priority="secondary" size="small" onClick={closeReplyModal}>
          {t('expert-replyreview-ctacancel')}
        </Button>
      }
    >
      <div style={{ padding: '0 30px' }}>
        <ReviewItem review={selectedReview} reviewInModal={true} />
        <div className={s.replyReviewModalReviewWrapper}>
          <div className={s.replyReviewModalAvatar}>
            <Avatar
              color="A1"
              imgProps={{
                src: expertDetails.profilePhoto,
              }}
              name={expertDetails.name}
              size="size60"
            />
          </div>
          <div className={s.replyReviewModalFormFieldWrapper}>
            <FormField label={t('expert-replyreview-fieldtitle')}>
              <InputArea
                dataHook="reply-to-review-input-area"
                hasCounter={true}
                maxLength={500}
                rows={4}
                onChange={onInputAreaChange}
                placeholder={t('expert-replyreview-placeholder')}
              />
            </FormField>
          </div>
        </div>
      </div>
    </CustomModalLayout>
  );
};

export default translate()(ReplyReviewModalLayoutDesktop);
